export const EditParticipantType = "EditParticipantType";
export const CreateParticipantType = "CreateParticipantType";
export const InviteMemberType = "InviteMemberType";
